module.exports = __webpack_public_path__ + "media/service_features/various_projects-0eb40878.svg";